import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AccountContext } from "./contexts/accountContext";
import { AdminShellProvider } from "./contexts/adminShellContext";
import Cookies from "js-cookie";
// import Cookies from "js-cookie";

// import { useSelector } from "react-redux";
const PrivateRoute = ({ component: Component, ...rest }) => {
  const { state } = useContext(AccountContext);
  // console.log("here state", state);
  const token = Cookies.get("token");
  // const tokenn = useSelector((state) => state.adminToken);
  // console.log(tokenn, "sdjfdiudsfhdfiu");
  // console.log("state.loged", state.loged);
  // console.log("state.adminToken", state.adminToken);
  return (
    <Route
      {...rest}
      render={(props) => {
        if ((state.adminToken && state.loged) || token) {
          // Every protected screen is themed and gets shell state from here,
          // so no screen file needs to know about either. Deliberately a plain
          // div: `transform`/`filter`/`contain` here would make it the
          // containing block and break the fixed-position mobile drawer.
          return (
            <AdminShellProvider>
              <div className="tfmadm">
                <Component {...props} />
              </div>
            </AdminShellProvider>
          );
        } else {
          return <Redirect to={"/login"} />;
        }
      }}
    />
  );
};

export default PrivateRoute;
